// extracted by mini-css-extract-plugin
module.exports = {"container":"test_cards_list-module_container_4433a","title":"test_cards_list-module_title_5c255","required":"test_cards_list-module_required_a9755"};